// @flow
import zip from 'lodash/zip';
import findIndex from 'lodash/findIndex';
import moment from 'moment';
import loadGoogleMapsApi from 'load-google-maps-api';
import {
  call,
  takeLatest,
  takeEvery,
  put,
  select,
  race,
  all,
} from 'redux-saga/effects';
import { normalize } from 'normalizr';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import i18n from 'i18n-js';

import {
  REQUEST_TIMEOUT,
  GOOGLE_MAPS_API_KEY,
} from '../settings';
import { fibonacciBackoff } from '../lib/retry';
import { throwTimeout, get } from '../lib/http';
import HTTP_STATUS from '../lib/HTTPStatus';
// import { addMeta } from '../actions/common';
import {
  ROUTE_PATH_FETCH_STARTED,
  ROUTE_FETCH_STARTED,
  CREATE_ROUTE_STARTED,
  SORT_ROUTE_STOP_STARTED,
  UPDATE_ROUTE_STARTED,
  DELETE_ROUTE_STARTED,
  ROUTE_STOP_ADDED,
  ROUTE_STOP_REMOVED,
  ROUTE_STOP_SELECTED,
  ROUTE_STOP_FETCH_STARTED,
  ROUTE_STOP_STUDENTS_FETCH_STARTED,
  ROUTE_STOP_STUDENT_ADDED,
  ROUTE_STOP_UPDATED,
  SCHOOL_ROUTES_FETCH_STARTED,
  DELETE_ROUTE_STOP_STUDENT_STARTED,
  ROUTE_STOPS_FETCH_STARTED,
  ROUTE_STOPS_STUDENT_ASSIGN_STARTED,
} from '../types/routes';
import * as selectors from '../reducers';
import * as closeableActions from '../actions/closeable';
import * as mapsActions from '../actions/map';
import * as studentsActions from '../actions/students';
import * as monitorsActions from '../actions/monitors';
import * as driversActions from '../actions/drivers';
import * as busesActions from '../actions/buses';
import * as routesActions from '../actions/routes';
import {
  Routes,
  RouteStops,
  OmniSearch,
  Students,
} from '../api';
import {
  arrayOfRoutes,
  route,
} from '../api/schemas/routes';
import { arrayOfStudents } from '../api/schemas/students';
import { arrayOfRouteStops } from '../api/schemas/routeStops';
import * as temporalBannersActions from '../actions/temporalBanners';
import {
  DEFAULT_CREATE, DEFAULT_DURATION, DEFAULT_REMOVE, DEFAULT_UPDATE, CREATE_ERROR, UPDATE_ERROR, REMOVE_ERROR,
} from '../utils/errorDefaults';


const getDirections = (api: Object, service: Object, ori: Array<number>, dst: Array<number>) => new Promise(
  (resolve, reject) => {
    const origin = new api.LatLng(ori[1], ori[0]);
    const destination = new api.LatLng(dst[1], dst[0]);
    service.route(
      {
        origin,
        destination,
        travelMode: api.TravelMode.DRIVING,
      },
      resolve,
    );
  },
);

const getDistance = (api: Object, service: Object, ori: Array<number>, dst: Array<number>, departureTime: Date) => new Promise(
  (resolve, reject) => {
    const origin = new api.LatLng(ori[1], ori[0]);
    const destination = new api.LatLng(dst[1], dst[0]);

    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: api.TravelMode.DRIVING,
        drivingOptions: {
          trafficModel: api.TrafficModel.BEST_GUESS,
          departureTime,
        },
      },
      resolve,
    );
  },
);


function* updateRouteStopsETAs(stops: Array<ROUTE_STOP>, expectedDepartureTime: string) {
  // const gapi = yield call(loadGoogleMapsApi, { key: GOOGLE_MAPS_API_KEY, libraries: ['places'], });
  // const distanceMatrixService = new gapi.DistanceMatrixService();
  // const firstStop = stops[0];
  // const route = yield select(selectors.getRoute, firstStop.route);
  //
  // const startOfDay = new Date(Date.now() + 86400000); // Tomorrow
  // startOfDay.setHours(0,0,0,0);
  // const UTCdepartureTime = moment.utc(expectedDepartureTime, 'HH:mm a');
  // const localDepartureTime = moment.utc(UTCdepartureTime).local().format('HH:mm');
  // const startSeconds = moment.duration(localDepartureTime).asSeconds();
  // let currentSeconds = startSeconds;
  //
  // for (let i = 0; i < stops.length; i++) {
  //   const currentStop = stops[i];
  //
  //   let eta = 0;
  //   if (i !== 0) {
  //     const lastStop = stops[i - 1];
  //     const response = yield call(
  //       getDistance,
  //       gapi,
  //       distanceMatrixService,
  //       lastStop.point.coordinates,
  //       currentStop.point.coordinates,
  //       new Date(startOfDay + currentSeconds * 1000),
  //     );
  //
  //     const { rows } = response;
  //
  //     if (rows.length > 0 && rows[0].elements.length > 0) {
  //       const element = rows[0].elements[0];
  //       if ('duration' in element) {
  //         eta = element.duration.value;
  //       }
  //     }
  //   }
  //
  //   // Update time
  //   currentSeconds = (currentSeconds + eta) % 86400; // 60 * 60 * 24;
  //   const duration = moment.duration(currentSeconds, 'seconds');
  //
  //   // Update stop
  //   yield put(
  //     routesActions.updateRouteStop({
  //       id: currentStop.id,
  //       eta: moment.utc(duration.as('milliseconds')).format('HH:mm:ss'),
  //     })
  //   );
  // }
}

function* updateRouteSegmentPath(stops, clearLast) {
  // // Set map loading
  // yield put(mapsActions.setMapLoading('Recalculando ruta'));
  //
  // // Clear path for orphans
  // if (stops.length === 1 && stops[0].path_to_next_stop.length > 0) {
  //   yield put(routesActions.updateRouteStop({
  //     id: stops[0].id,
  //     path_to_next_stop: [],
  //   }));
  // } else if (stops.length > 1) {
  //   const startsObjects = stops.slice(0, stops.length - 1);
  //   const starts = startsObjects.map(({ point: { coordinates } }) => coordinates);
  //   const ends = stops.slice(1).map(({ point: { coordinates } }) => coordinates);
  //   // Zip!
  //   const pairs = zip(starts, ends);
  //
  //   const gapi = yield call(loadGoogleMapsApi, { key: GOOGLE_MAPS_API_KEY, libraries: ['places'] });
  //   const directionsService = new gapi.DirectionsService();
  //
  //   // Get all paths
  //   const responses = yield all(
  //     pairs.map(
  //       pair => call(
  //         getDirections,
  //         gapi,
  //         directionsService,
  //         pair[0],
  //         pair[1],
  //       ),
  //     ),
  //   );
  //
  //   const subPaths = responses.map((response) => {
  //     if (response && response != null) {
  //       const { routes } = response;
  //       const { overview_polyline } = routes[0];
  //       const subPath = gapi.geometry.encoding.decodePath(overview_polyline);
  //
  //       return subPath.map(coordinate => ({
  //         longitude: coordinate.lng(),
  //         latitude: coordinate.lat(),
  //       }));
  //     }
  //     return [];
  //
  //   });
  //
  //   const stopPathRel = zip(startsObjects, subPaths);
  //
  //   for (let i = 0; i < stopPathRel.length; i += 1) {
  //     const [stop, subPath] = stopPathRel[i];
  //     yield put(routesActions.updateRouteStop({
  //       id: stop.id,
  //       path_to_next_stop: subPath,
  //     }));
  //   }
  //
  //   if (clearLast) {
  //     const lastStop = stops[stops.length - 1];
  //     yield put(routesActions.updateRouteStop({
  //       id: lastStop.id,
  //       path_to_next_stop: [],
  //     }));
  //   }
  // }
  //
  // // Unset map loading
  // yield put(mapsActions.unsetMapLoading());
}

function* fetchRoutePath(action) {
  const id = action.payload;

  try {
    // Get stops
    const routeObject = yield select(selectors.getRoute, id);
    const stops = yield select(selectors.getRouteStops, routeObject.id);
    // If at least two stops without path_to_next_stop or a single-stop
    if (
      (
        stops.length > 1
        && stops.filter(stop => stop.path_to_next_stop.length === 0).length > 1
      ) || (stops.length === 1)
    ) {
      yield updateRouteSegmentPath(stops);
    }
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.fetchRoutesFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'No tienes ruta siguiente' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* createRoute(action) {
  const token = yield select(selectors.getToken);
  const profile = yield select(selectors.getProfileOfType, 'admin');

  try {
    // Create  route
    const { routeResponse, timeout } = yield race({
      routeResponse: call(
        [Routes, 'create'],
        {
          token,
          data: {
            route_type: action.payload.type,
            week_days: action.payload.week_days,
            expected_departure_time: action.payload.expected_departure_time,
            expected_completion_time: action.payload.expected_completion_time,
            name: action.payload.name,
            school: profile.school,
            bus: parseInt(action.payload.bus, 10),
            short_name: action.payload.name,
            driver: parseInt(action.payload.driver, 10),
            monitor: parseInt(action.payload.monitor, 10),
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRoutes saga');
    }

    yield put(routesActions.createRouteSuccess({ ...routeResponse, id: routeResponse.id.toString() }));

    const routes = yield select(selectors.getRoutesOrder);
    yield put(temporalBannersActions.shout(DEFAULT_CREATE(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(routesActions.updateVisibleRoutes(routes));
    yield put(closeableActions.close('createroute'));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(temporalBannersActions.shout(CREATE_ERROR(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, -1, {}));
    yield put(routesActions.createRouteFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al crear ruta' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* updateRoute(action) {
  const token = yield select(selectors.getToken);
  const { id, routeId } = action.payload;
  try {
    // Update  route
    const { routeResponse, timeout } = yield race({
      routeResponse: call(
        [Routes, 'update'],
        {
          token,
          id: id || routeId,
          data: {
            ...action.payload,
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('updateRoute saga');
    }
    // Update  route schedule
    if (action.payload.week_days) {
      const { updateScheduleResponse, timeout2 } = yield race({
        updateScheduleResponse: call(
          [Routes.custom, 'updateSchedule'],
          {
            token,
            id: id || routeId,
            data: {
              week_days: action.payload.week_days,
            },
          },
        ),
        timeout2: call(delay, REQUEST_TIMEOUT),
      });
    }

    // Update type
    let updatedRouteType;
    if (action.payload.type || action.payload.route_type) {
      const { updateRouteType, timeout3 } = yield race({
        updateRouteType: call(
          [Routes.custom, 'updateRouteType'],
          {
            token,
            id: id || routeId,
            data: {
              route_type: action.payload.type || action.payload.route_type,
            },
          },
        ),
        timeout2: call(delay, REQUEST_TIMEOUT),
      });
      updatedRouteType = updateRouteType;
      if (timeout3) {
        throwTimeout('updateRouteType schedule saga');
      }
    }


    const routeObject = yield select(selectors.getRoute, id || routeId);
    const { driver, bus, monitor } = routeResponse;
    const monitorId = monitor.profiles.filter(p => p.type === 'monitor')[0].id;
    const driverId = driver.profiles.filter(p => p.type === 'driver')[0].id;
    yield put(monitorsActions.startFetchingMonitor(monitorId));
    yield put(driversActions.startFetchingDriver(driverId));
    yield put(busesActions.startFetchingBus(bus));
    yield put(routesActions.updateRoutesSucceed({
      ...routeResponse,
      ...updatedRouteType,
      stops: routeObject.stops,
    }));
    yield put(temporalBannersActions.shout(DEFAULT_UPDATE(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(closeableActions.close('editRoutePopup'));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(temporalBannersActions.shout(UPDATE_ERROR(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(routesActions.updateRoutesFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al crear ruta' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* deleteRoute(action) {
  const { routeId } = action.payload;
  const token = yield select(selectors.getToken);

  try {
    // Create  route
    const { timeout } = yield race({
      routeResponse: call(
        [Routes, 'remove'],
        { token, id: routeId },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('deleteRoute saga');
    }

    yield put(routesActions.deleteRouteSuccess(route));
    yield put(push('/admin/backend/routes'));
    yield put(closeableActions.close(`confirmDeleteRoute${routeId}`));
    yield put(temporalBannersActions.shout(DEFAULT_REMOVE(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, 1, {}));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(temporalBannersActions.shout(REMOVE_ERROR(i18n.t('labels.route', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(routesActions.createRouteFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al crear ruta' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* deleteRouteStopStudent(action) {
  const { routeStopId, studentId } = action.payload;
  const token = yield select(selectors.getToken);
  const student = yield select(selectors.getStudent, studentId);

  const mock = {
    delay: 1000,
    response: {
      statusCode: 200,
      body: {
        id: Math.floor(1000000 + (Math.random() * 10000000)),
      },
    },
  };

  try {
    // Create  route
    const { timeout } = yield race({
      routeResponse: call(
        [RouteStops.custom, 'removeStudent'],
        {
          token,
          id: routeStopId,
          data: { student: studentId },
          mock,
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('deleteRouteStopStudent saga');
    }

    yield put(studentsActions.updateStudentSuccess({
      ...student,
      route_stops: student.route_stops.filter(s => s !== parseInt(routeStopId, 10)),
    }));
    yield put(routesActions.deleteRouteStopStudentSuccess(routeStopId));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.deleteRouteStopStudentFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al eliminar asignacion a parada' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* sortRouteStop(action) {
  const token = yield select(selectors.getToken);

  try {
    // Create  route
    const { routeResponse, timeout } = yield race({
      routeResponse: call(
        [Routes.custom, 'sortStop'],
        {
          token,
          id: action.payload.routeId,
          data: { ordinal: action.payload.index, stop_id: action.payload.stopId },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('sortRouteStop saga');
    }

    const {
      entities: {
        routes,
      },
    } = normalize(routeResponse, route);

    yield put(routesActions.sortRouteStopSuccess(routes[routeResponse.id]));

    const stops = yield select(selectors.getRouteStops, action.payload.routeId);

    // Update route path
    yield updateRouteSegmentPath(stops, true);

    // Update etas
    const routeObject = yield select(selectors.getRoute, action.payload.routeId);
    yield updateRouteStopsETAs(stops, routeObject.expected_departure_time);
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.sortRouteFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al crear ruta' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* fetchRoute(action) {
  const token = yield select(selectors.getToken);
  const id = action.payload;
  try {
    // Fetch the next route
    const { routeResponse, timeout } = yield race({
      routeResponse: call(
        [Routes, 'detail'],
        { id, token /* timestamp */},
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRoute saga');
    }

    const { driver, bus, monitor } = routeResponse;
    const monitorId = monitor ? monitor.profiles.filter(p => p.type === 'monitor')[0].id : undefined;
    const driverId = driver.profiles.filter(p => p.type === 'driver')[0].id;
    // Set current route
    yield put(routesActions.setCurrentRoute(id));
    // Mark the fetching as completed
    yield put(routesActions.fetchRouteSucceed(routeResponse));


    // Fetch related models
    yield put(monitorsActions.startFetchingMonitor(monitorId));
    yield put(driversActions.startFetchingDriver(driverId));
    yield put(busesActions.startFetchingBus(bus));
    yield put(routesActions.startFetchingRouteStops(id));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.fetchRoutesFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'No tienes ruta siguiente' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* fetchRouteStops(action) {
  const token = yield select(selectors.getToken);
  const id = action.payload;

  try {
    // Fetch the next route
    const { routeStopsResponse, timeout } = yield race({
      routeStopsResponse: call(
        [Routes.custom, 'stops'],
        { id, /* timestamp */ token },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRouteStops saga');
    }

    const {
      entities: { routeStops },
      result,
    } = normalize(routeStopsResponse, arrayOfRouteStops);

    // Register route stops
    yield put(routesActions.fetchRouteStopsSucceed(id, routeStops, result));

    // Check if it's viewing their route
    if (result.length > 0) {
      const currentRoute = yield select(selectors.getCurrentRoute);
      const sampleStop = routeStops[result[0]];

      if (sampleStop.route === currentRoute.id) {
        let stopId;
        let stop;
        if (typeof currentRoute.stops[0] === 'object') {
          stopId = currentRoute.stops[0].id;
          stop = currentRoute.stops[0];
        } else {
          stopId = currentRoute.stops[0];
          stop = yield select(selectors.getRouteStop, stopId);
        }
        const {
          point: { coordinates },

        } = stop;
        if (currentRoute.bus) {
          const busObj = yield select(selectors.getBus, currentRoute.bus);
          if (busObj && busObj.location) {
            yield put(mapsActions.setMapPosition(
              15,
              busObj.location.longitude,
              busObj.location.latitude,
              true,
            ));
          } else {
            yield put(mapsActions.setMapPosition(
              15,
              coordinates[0],
              coordinates[1],
              true,
              { longitude: -0.50, latitude: 0.50 },
            ));
          }
        } else {
          yield put(mapsActions.setMapPosition(
            15,
            coordinates[0],
            coordinates[1],
            true,
            { longitude: -0.50, latitude: 0.50 },
          ));
        }


        // Set map pristine
        yield put(mapsActions.setMapPristine());

        // Get route path after fetching the stops
        yield put(routesActions.startFetchRoutePath(id));
      }
    }
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(routesActions.fetchRouteStopFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: id,
    }));
  }
}

function* fetchSchoolRoutes(action) {
  const token = yield select(selectors.getToken);
  const { schoolId, text } = action.payload;
  yield call(delay, 200);
  try {
    // Fetch the next route
    const { routesResponse, timeout } = yield race({
      routesResponse: call(
        [OmniSearch.custom, 'search'],
        {
          token,
          filters: {
            school: schoolId,
            text,
            limit: 100,
            result_type: 'route',
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRoutes saga');
    }

    const { entities, result } = normalize(routesResponse.results, arrayOfRoutes);

    // Mark the fetching as completed

    yield put(routesActions.fetchRoutesSucceed(entities.routes, result));
    yield put(routesActions.updateVisibleRoutes(result));

    // // Register route stops
    // yield put(routesActions.fetchRouteStopsSucceed(
    //   result,
    //   routeStops,
    // ));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.fetchRoutesFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'No tienes ruta siguiente' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* addRouteStop(action) {
  const { payload } = action;
  const { id, stops = [] } = yield select(selectors.getRoute, payload.route);
  const token = yield select(selectors.getToken);

  try {
    // const mock = {
    //   delay: 1000,
    //   response: {
    //     statusCode: 200,
    //     body: {
    //       id: Math.floor(1000000 + Math.random() * 10000000)
    //     }
    //   }
    // };

    // Fetch the next route
    const { response, timeout } = yield race({
      response: call(
        [RouteStops, 'create'],
        {
          token,
          data: {
            ...payload,
            short_name: `${stops.length + 1}`,
            human_name: payload.name,
          },
          /* , mock */
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('addRouteStop saga');
    }

    const oldId = payload.id;
    const newId = response.id;

    yield put(routesActions.confirmRouteStop(
      oldId,
      newId,
      response,
    ));

    // Sync
    yield put(routesActions.updateRoute(id, {
      stops: [...stops, newId],
    }));

    yield put(routesActions.setCurrentRouteStop(newId));

    const stopObjects = yield select(selectors.getRouteStops, payload.route);
    if (stopObjects.length > 1) {
      // Update path
      yield updateRouteSegmentPath(stopObjects.slice(stopObjects.length - 2));

      // Update etas
      const routeObject = yield select(selectors.getRoute, payload.route);
      yield updateRouteStopsETAs(stopObjects, routeObject.expected_departure_time);
    }

    // Update route path
    yield put(routesActions.startFetchRoutePath(payload.route));
  } catch (_e) {
    // TODO: handle error
  }
}

function* updateRouteStop(action) {
  const { payload } = action;
  const token = yield select(selectors.getToken);

  try {
    // const mock = {
    //   delay: 1000,
    //   response: {
    //     statusCode: 200,
    //     body: {}
    //   }
    // };

    // Fetch the next route
    const { timeout } = yield race({
      response: call(
        [RouteStops, 'update'],
        { token, id: payload.id, data: payload },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('updateRouteStop saga');
    }

    // Update route path
    if (payload.pointUpdated) {
      // Generate the updating segment
      const stop = yield select(selectors.getRouteStop, payload.id);
      const stops = yield select(selectors.getRouteStops, stop.route);
      const stopIndex = findIndex(stops, ['id', stop.id]);
      const segment = [];

      if (stopIndex === 0) {
        segment.push(stops[stopIndex]);
      } else {
        segment.push(stops[stopIndex - 1], stops[stopIndex]);
      }

      if (stopIndex < stops.length - 1) {
        segment.push(stops[stopIndex + 1]);
      }

      // Update path
      yield updateRouteSegmentPath(segment);

      // Update etas
      const routeObject = yield select(selectors.getRoute, stop.route);
      yield updateRouteStopsETAs(stops, routeObject.expected_departure_time);
    }
    if (payload.updateName) {
      yield put(closeableActions.close('editRouteStop'));
    }
  } catch (_e) {
    // TODO: handle error
  }
}

function* removeRouteStop(action) {
  const token = yield select(selectors.getToken);
  const { meta } = action;
  const stopId = action.payload;
  const routeObject = meta.route;

  try {
    yield call(
      fibonacciBackoff,
      [RouteStops, 'remove'],
      { token, id: stopId },
    );
  } catch (_e) { /* noop */ }

  // Sync stops
  yield put(routesActions.updateRoute(routeObject.id, {
    stops: routeObject.stops.filter(sId => sId !== stopId),
  }));

  // Update route path
  const { index } = meta;
  const stops = yield select(selectors.getRouteStops, routeObject.id);

  if (index > 0) {
    const segment = [stops[index - 1]];
    if (stops.length > index) {
      segment.push(stops[index]);
    }

    // Update path
    yield updateRouteSegmentPath(segment);

    // Update etas
    const newRouteObject = yield select(selectors.getRoute, routeObject.id);
    yield updateRouteStopsETAs(stops, newRouteObject.expected_departure_time);
  }
}

function* afterRouteStopSelected(action) {
  const routeStopId = action.payload;
  const { point: { coordinates } } = yield select(selectors.getRouteStop, routeStopId);

  // Center map in route stop
  yield put(mapsActions.setMapPosition(
    17,
    coordinates[0],
    coordinates[1],
    true,
    { longitude: -0.50, latitude: 0.50 },
  ));

  yield put(mapsActions.setMapPristine());

  yield put(routesActions.startFetchingRouteStopStudents(routeStopId));
}

function* fetchRouteStopStudents(action) {
  const routeStopId = action.payload;
  const token = yield select(selectors.getToken);

  try {
    // const mock = {
    //   delay:  1000,
    //   response: {
    //     statusCode: 200,
    //     body: [
    //       {
    //         id: 1,
    //         first_name: 'Lalo',
    //         last_name: 'Cazasola',
    //         profile_picture: 'https://pbs.twimg.com/profile_images/3084832869/0913fb31ee001c9b5c6cda011ac8e465_400x400.jpeg',
    //         code: '1234',
    //         school: 1
    //       }
    //     ]
    //   }
    // };

    // Create  route
    const { studentsResponse, timeout } = yield race({
      studentsResponse: call(
        [RouteStops.custom, 'students'],
        { token, id: routeStopId },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRouteStopStudents saga');
    }

    const {
      entities: { students },
      result = [],
    } = normalize(studentsResponse, arrayOfStudents);

    yield put(routesActions.completeRouteStopsStudentFetch(
      routeStopId,
      result,
      students,
    ));

    yield put(studentsActions.fetchStudentsSucceed(students, result));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(routesActions.failRouteStopsStudentFetch({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: routeStopId,
    }));
  }
}

function* addStudentToRouteStop(action) {
  const { id, student } = action.payload;
  const stop = yield select(selectors.getRouteStop, id);
  const students = stop ? stop.students : [];

  const token = yield select(selectors.getToken);

  // Add student to routestop
  if (!students.includes(student.id)) {
    try {
      const { response, timeout } = yield race({
        response: call(
          [RouteStops.custom, 'addStudent'],
          { token, id, data: { student: student.id } },
        ),
        timeout: call(delay, REQUEST_TIMEOUT),
      });

      if (timeout) {
        throwTimeout('addStudentToRouteStop saga');
      }

      yield put(studentsActions.fetchStudentSucceed(student));
      yield put(routesActions.updateRouteStop({
        id,
        students: [...students, student.id],
      }));

    } catch (_e) { }
  }
}

function* assignStudentToStops(action) {
  const { stops, student } = action.payload;
  const token = yield select(selectors.getToken);

  const stopsSchedules = [];
  const hasError = false;

  for (let i = 0; i < stops.length; i++) {
    const stop = stops[i];

    // Add student to stop
    try {
      const { response, timeout } = yield race({
        response: call(
          [RouteStops.custom, 'addStudent'],
          {
            token,
            id: stop.id,
            data: {
              student,
              week_days: stop.week_days || [],
            }
          },
        ),
        timeout: call(delay, REQUEST_TIMEOUT),
      });

      if (timeout) {
        throwTimeout('addStudentToRouteStop saga');
      }

    } catch (error) {
      hasError = true;
      const { statusCode } = error;

      yield put(temporalBannersActions.shout(
        i18n.t('temporalBanners.assignStopError', { Code: statusCode, Item: stop.name }), 3000, '-1', {},
      ));
    }
  }

  if (!hasError) {
    yield put(routesActions.completeStudentAssignmnetToStops());
    yield put(temporalBannersActions.shout(i18n.t('temporalBanners.assignStopSuccess'), 3000, 1, {}));
  }
}

function* fetchRouteStop(action) {
  const id = action.payload;
  const token = yield select(selectors.getToken);
  try {
    // Fetch the next route
    const { routeStopResponse, timeout } = yield race({
      routeStopResponse: call(
        [RouteStops, 'detail'],
        { id, /* timestamp */ token },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRouteStop saga');
    }

    // Register route stops
    yield put(routesActions.fetchRouteStopSucceed(routeStopResponse));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(routesActions.fetchRouteStopFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: id,
    }));
  }
}


export function* watchRoutesFetch(): Iterator<any> {
  yield takeEvery(
    ROUTE_FETCH_STARTED,
    fetchRoute,
  );
}

export function* watchRouteStopsFetch(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOPS_FETCH_STARTED,
    fetchRouteStops,
  );
}

export function* watchRoutesDirectionsFetch(): Iterator<any> {
  yield takeEvery(
    ROUTE_PATH_FETCH_STARTED,
    fetchRoutePath,
  );
}

export function* watchCreateRoute(): Iterator<any> {
  yield takeEvery(
    CREATE_ROUTE_STARTED,
    createRoute,
  );
}

export function* watchSortStop(): Iterator<any> {
  yield takeEvery(
    SORT_ROUTE_STOP_STARTED,
    sortRouteStop,
  );
}

export function* watchRouteDelete(): Iterator<any> {
  yield takeEvery(
    DELETE_ROUTE_STARTED,
    deleteRoute,
  );
}

export function* watchRouteStopAdded(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_ADDED,
    addRouteStop,
  );
}

export function* watchRouteStopRemoved(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_REMOVED,
    removeRouteStop,
  );
}

export function* watchRouteStopSelected(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_SELECTED,
    afterRouteStopSelected,
  );
}


export function* watchRouteStopStudentsFetchStarted(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_STUDENTS_FETCH_STARTED,
    fetchRouteStopStudents,
  );
}

export function* watchSchoolRoutesFetchStarted(): Iterator<any> {
  yield takeLatest(
    SCHOOL_ROUTES_FETCH_STARTED,
    fetchSchoolRoutes,
  );
}

export function* watchRouteStopUpdated(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_UPDATED,
    updateRouteStop,
  );
}

export function* watchRouteStopStudentAdded(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_STUDENT_ADDED,
    addStudentToRouteStop,
  );
}

export function* watchRouteUpdate(): Iterator<any> {
  yield takeEvery(
    UPDATE_ROUTE_STARTED,
    updateRoute,
  );
}

export function* watchDeleteRouteStopStudent(): Iterator<any> {
  yield takeEvery(
    DELETE_ROUTE_STOP_STUDENT_STARTED,
    deleteRouteStopStudent,
  );
}

export function* watchFetchRouteStop(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOP_FETCH_STARTED,
    fetchRouteStop,
  );
}

export function* watchAssignStudentToStops(): Iterator<any> {
  yield takeEvery(
    ROUTE_STOPS_STUDENT_ASSIGN_STARTED,
    assignStudentToStops,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/routes.js